import Im from "immutable";
import Moment from "moment";
import { _trim } from "./tableRow";
import { optionsMapToList } from "./tableRow";

export const isNumber = (value) => {
  if (isNullOrEmpty(value) || (typeof value !== "string" && typeof value !== "number")) return false;
  return isFinite(Number(value));
};

const isPostcode = (value) => {
  if (!(typeof value === "string")) {
    return false;
  }
  if (!value.includes(" ")) {
    return false;
  }
  let parts = value.split(" ");
  if (!(parts.length === 2)) {
    return false;
  }
  if (!(parts[0].length >= 2 && parts[0].length <= 4)) {
    return false;
  }
  return parts[1].length === 3;
};

const isDate = (value) => {
  if (typeof value !== "string" || !value.trim()) return false;
  const date = Moment(value.trim(), "DD/MM/YYYY", true);
  return date.isValid();
};

const validatorMap = {
  string: {
    func: null,
    message: "Value must be a string",
  },
  number: {
    func: isNumber,
    message: "Please enter a number",
  },
  postcode: {
    func: isPostcode,
    message: "Value must be a postcode",
  },
  freetext: {
    func: null,
    message: "Value must be a string",
  },
  selection: {
    func: (value, field, values) => {
      let options = optionsMapToList(field.get("options"), values);
      let required = field.get("required");
      if (isNullOrEmpty(value)) return !required;
      return options.map((i) => _trim(i)).contains(value);
    },
    message: "Please select one of the choices available",
  },
  date: {
    func: isDate,
    message: "Value must be a valid date in the format dd/mm/yyyy",
  },
};

const isNullOrEmpty = (value) => {
  value = typeof value === "string" ? value.trim() : value;

  return value === null || value === undefined || value === "";
};

export const validateFields = (fields, values) => {
  let errors = Im.Map();

  console.log("validateFields", values?.toJS());
  // If there is no data entered then return empty errors object
  if (!values?.size) return errors;

  for (let field of fields) {
    let header = field.get("header");
    let value = values.get(header);

    // Check if there is a value
    let required = field.get("required");
    if (required && isNullOrEmpty(value)) {
      errors = errors.set(header, "This field is required");
      continue;
    }

    let fieldType = field.get("type");
    let validator = validatorMap[fieldType];

    if (!validator || !validator.func) {
      continue;
    }

    if (!isNullOrEmpty(value) && !validator.func(value, field, values)) {
      errors = errors.set(header, validator.message);
    }
  }
  return errors;
};
